module.exports = __webpack_public_path__ + "static/media/darma.34e86d17.png";